import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import "./RecipeListPage.css"
import CommonDivWidget from 'components/CommonDivWidget/CommonDivWidget'
import { message, Spin , DatePicker, Row, Col, Tag} from 'antd';
import CommonButton from 'components/ButtonWidgets/CommonButton/CommonButton';
import { TitleSearch } from 'components/SearchWidget/TitleSearch';
import { apiDeleteRecipe, apiGetRecipeBasicData, apiGetRecipeList } from 'services/recipeService';
import RecipeListTableWidget from './TableWidget/RecipeListTableWidget';
import { useHistory } from 'react-router-dom';
import { ROUTE_RECIPE_ADD, ROUTE_RECIPE_EDIT } from 'navigation/CONSTANTS';
import { UpdateCurrentRoot } from 'redux/actions/appActions';
const { RangePicker } = DatePicker;

function RecipeListPage() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isBusy, setIsBusy] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [searchList, setSearchList] = useState([]);

    const [recipeBasicData, setRecipeBasicData] = useState({});
    const [ownCommonData, setOwnCommonData] = useState({});
    useEffect(() => {
        setIsBusy(true)
        apiGetRecipeBasicData(null)
            .then((data) => {
                setRecipeBasicData(data);
                getRecipeData(data)
            })
            .catch((err) => {
                setIsBusy(false)
                // message.error("Sorry! " + err);
            });
    }, []);

    const getRecipeData = (data) => {
        const { categoryList } = data === undefined ? { categoryList: undefined } : data;
        const { unitList } = data === undefined ? { unitList: undefined } : data;
        const { locationList } = data === undefined ? { locationList: undefined } : data;
        const { subRecipeList } = data === undefined ? { subRecipeList: undefined } : data;
        const { salableTypeList } = data === undefined ? { salableTypeList: undefined } : data;
        
        
        if (data != undefined && data.subRecipeList !== undefined) {
            setOwnCommonData({
                locationList: locationList,
                unitList: unitList,
                categoryList: categoryList,
                subRecipeList: subRecipeList,
                salableTypeList: salableTypeList,
            })
            setIsBusy(true)
            apiGetRecipeList()
                .then((res) => {
                    setDataList(res);
                    setSearchList(res)
                    setIsBusy(false);
                })
                .catch((err) => {
                    setIsBusy(false);
                    message.error(err);
                });
        }
    }
    /*
    const prepareRecipeData = (data, ownData) => {

        for (let i = 0; i < data.length; i++) {
            let guideList = data[i].guideList
            for (let j = 0; j < guideList.length; j++) {
                let dataList = guideList[j].dataList
                let total_enter_qty = 0
                let total_price = 0
                let ingredient_name = ""
                for (let k = 0; k < dataList.length; k++) {
                    total_enter_qty = parseFloat(total_enter_qty) + parseFloat(dataList[k].enter_qty)
                    let price = 0
                    if (dataList[k].reference_inv_name_id !== "-1") {
                        let invName = ownData.invNameList.filter(e => e.id === dataList[k].reference_inv_name_id)[0]
                        if (invName !== undefined) {
                            price = parseFloat(invName.average_price_per_unit)
                            ingredient_name = invName.name
                        }
                        else {
                            message.error("Sorry! invName" + dataList[k].reference_inv_name_id + " is Missing!")
                        }
                    }
                    else if (dataList[k].yield_name_id !== "-1") {
                        let yieldName = ownData.yieldNameList.filter(e => e.id === dataList[k].yield_name_id)[0]
                        if (yieldName !== undefined) {
                            price = parseFloat(yieldName.average_price_per_unit)
                            ingredient_name = yieldName.name
                        }
                        else {
                            message.error("Sorry! yieldName" + dataList[k].yield_name_id + " is Missing!")
                        }
                    }
                    else if (dataList[k].yield_rule_id === "-1") {
                        let invName = ownData.invNameList.filter(e => e.id === dataList[k].inv_name_id)[0]
                        if (invName !== undefined) {
                            price = parseFloat(invName.average_price_per_unit)
                            ingredient_name = invName.name
                        }
                        else {
                            message.error("Sorry! invName" + dataList[k].inv_name_id + " is Missing!")
                        }
                    }
                    total_price = parseFloat(total_price) + parseFloat(dataList[k].enter_qty) * parseFloat(price)
                }
                guideList[j]["total_enter_qty"] = total_enter_qty.toFixed(2)
                guideList[j]["total_price"] = total_price.toFixed(2)
                guideList[j]["name"] =  ingredient_name 

            }
        }
        setDataList(data);
        setSearchList(data)
    }
*/
    const handleSearch = (searchText) => {
        const tmpList = dataList.filter((info) => info.name.toLowerCase().includes(searchText.toLowerCase()))
        setSearchList([...tmpList])
    };
    const handleChange = (event) => {
        if (event.target.value === "") {
            setSearchList(dataList)
        }
        else {
            handleSearch(event.target.value)
        }
    };
    const onClickDelete = (pInfo) => {
        setIsBusy(true);
        apiDeleteRecipe(pInfo.id)
            .then((data) => {
                setIsBusy(false);
                let updateData = [...dataList];
                var storeIndex = updateData.findIndex(x => x.id == pInfo.id);
                updateData.splice(storeIndex, 1);
                setDataList(updateData);
                setSearchList(updateData)

            })
            .catch((err) => {
                setIsBusy(false);
                message.error("Error. " + err);
            });
    }
    const onClickEdit = (pInfo) => {
        dispatch(UpdateCurrentRoot({ currentRoute: ROUTE_RECIPE_EDIT }))
        history.push(ROUTE_RECIPE_EDIT + "/" + pInfo.id)

    }
    const handleDateFilter = (startDate, endDate) => {
        if (startDate == "" || endDate == "") {
            setSearchList([...dataList])
        } else {
            const start_date = new Date(startDate + "T00:00:00");
            const end_date = new Date(endDate + "T23:59:59");
            const tmpList = dataList.filter((info) => start_date <= new Date(info.update_timestamp.replace(/ /g, "T")) && new Date(info.update_timestamp.replace(/ /g, "T")) <= end_date)
            setSearchList([...tmpList])
        }
    }
    return (
        <CommonDivWidget>
            <Spin spinning={isBusy}>
                <Row>
                    <Col>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>Date Filter Period : &nbsp;&nbsp;
                            <RangePicker size={'default'}
                                onChange={(e, date) => {
                                    if (date == null) {
                                        handleDateFilter("", "")
                                    } else {
                                        handleDateFilter(date[0], date[1])
                                    }

                                }} />
                        </div>
                    </Col>
                    <Col flex={'auto'}>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>
                            <TitleSearch
                                onSearch={handleSearch}
                                onChange={handleChange}
                                onPressEnter={handleSearch}
                            />
                        </div>
                    </Col>
                </Row>
                <div>
                    <Tag color={"#60a8dc"} >
                        Inventory
                    </Tag>
                    <Tag color={"#f68b43"} >
                        Yield
                    </Tag>
                    <Tag color={"#9dce74"} >
                        SubRecipe
                    </Tag>
                </div>
                <div>
                    <RecipeListTableWidget
                        dataList={searchList}
                        ownCommonData={ownCommonData}
                        onUpdateAction={onClickEdit}
                        onDeleteAction={onClickDelete}
                    />
                </div>
            </Spin>
        </CommonDivWidget>
    )
}

export default RecipeListPage
